import React from 'react';
import { Link } from 'react-router-dom';
import { usePageMeta } from '../components/Layout';
import { Reveal, MarianaEmbed } from '../components/Shared';

export default function Buy() {
  usePageMeta(
    'Buy Classes, Memberships & Gift Cards — PITFIT Dallas',
    'Buy PITFIT classes, class packs, memberships and gift cards in seconds. $15 first class or 2 weeks unlimited for $50 for new clients — checkout synced with the studio.'
  );

  return (
    <section className="section-pad min-h-[70vh]">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <Reveal>
          <p className="mono-label mb-4">Quick Checkout</p>
          <h1 className="h-display !text-[clamp(2.2rem,4.5vw,3.4rem)] text-white">Buy classes & memberships.</h1>
          <p className="text-muted-pf mt-5 text-[17px] leading-relaxed max-w-2xl">
            First-time offers, class packs, memberships and gift cards — purchase in seconds, synced directly with the studio. New here? Start with the $15 first class or 2 weeks unlimited for $50.
          </p>
        </Reveal>
        <Reveal delay={100}>
          <div className="mt-8">
            <MarianaEmbed route="/buy/48717" testId="mariana-buy" />
          </div>
          <p className="text-muted-pf text-[13px] mt-3">
            Prefer to book a class first? <Link to="/book" className="underline underline-offset-4" style={{ color: 'var(--pf-brand2)' }}>Reserve a spot on the live schedule</Link> — see <Link to="/pricing" className="underline underline-offset-4" style={{ color: 'var(--pf-brand2)' }}>all pricing options</Link>.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
